import React from 'react';
import { FooterProps } from '../../../types';

const Footer: React.FC<FooterProps> = ({ tokenValid, tokenExpiry }) => {
  return (
    <div className="footer-info">
      <p>🔐 Secured by Keycloak</p>
      <p>✅ Token: {tokenValid ? 'Valid' : 'Invalid'}</p>
      <p>⏰ Expires: {tokenExpiry}</p>
    </div>
  );
};

export default Footer;
